import type { StatusTone } from "@/components/ui";
import type {
  KnowledgeAction,
  KnowledgeBaseStatus,
  PolicyAction,
  PolicyStatus,
} from "./types";

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

export function knowledgeStatusTone(status: KnowledgeBaseStatus): StatusTone {
  switch (status) {
    case "draft":
      return "info";
    case "under_review":
      return "warning";
    case "approved":
      return "info";
    case "published":
      return "success";
    case "superseded":
    case "archived":
      return "neutral";
    default:
      return "neutral";
  }
}

export function policyStatusTone(status: PolicyStatus): StatusTone {
  switch (status) {
    case "draft":
      return "info";
    case "under_review":
      return "warning";
    case "approved":
      return "info";
    case "active":
      return "success";
    case "superseded":
    case "retired":
      return "neutral";
    default:
      return "neutral";
  }
}

export const KNOWLEDGE_ACTIONS_FROM: Record<
  KnowledgeAction,
  readonly KnowledgeBaseStatus[]
> = {
  submit_review: ["draft"],
  approve: ["under_review"],
  publish: ["approved"],
  supersede: ["published"],
  archive: ["draft", "under_review", "approved", "published", "superseded"],
};

export const POLICY_ACTIONS_FROM: Record<
  PolicyAction,
  readonly PolicyStatus[]
> = {
  submit_review: ["draft"],
  approve: ["under_review"],
  activate: ["approved"],
  supersede: ["active"],
  retire: ["draft", "under_review", "approved", "active", "superseded"],
};

export function allowedKnowledgeActions(
  status: KnowledgeBaseStatus,
): KnowledgeAction[] {
  return (Object.keys(KNOWLEDGE_ACTIONS_FROM) as KnowledgeAction[]).filter(
    (action) => KNOWLEDGE_ACTIONS_FROM[action].includes(status),
  );
}

export function allowedPolicyActions(status: PolicyStatus): PolicyAction[] {
  return (Object.keys(POLICY_ACTIONS_FROM) as PolicyAction[]).filter((action) =>
    POLICY_ACTIONS_FROM[action].includes(status),
  );
}

export function toIsoUtc(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;
  return date.toISOString();
}
